import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  ApplicationConfig,
  importProvidersFrom,
  provideExperimentalZonelessChangeDetection,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withRouterConfig,
} from "@angular/router";
import {
  NbDialogModule,
  NbGlobalPhysicalPosition,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
} from "@nebular/theme";
import { CoreModule } from "./@core/core.module";
import { AnalyticsService } from "./@core/utils";
import { ThemeModule } from "./@theme/theme.module";
import { provideDataServices } from "./app.providers";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    // 1. Performance & Core
    provideExperimentalZonelessChangeDetection(),
    provideAnimations(), // Replaces BrowserAnimationsModule

    // 2. Routing
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: "always",
        onSameUrlNavigation: "reload",
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      })
    ),

    // 3. HTTP Client
    provideHttpClient(withInterceptorsFromDi()), // Replaces HttpClientModule

    // 4. Nebular & Legacy Modules
    // We use importProvidersFrom for modules that rely on the .forRoot() pattern
    importProvidersFrom(
      ThemeModule.forRoot(),
      NbSidebarModule.forRoot(),
      NbMenuModule.forRoot(),
      NbDialogModule.forRoot(),
      NbToastrModule.forRoot({
        position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
        duration: 3000,
      }),
      CoreModule.forRoot() // Ensures all your core services are provided
    ),
    // 5. Explicitly provide your custom services
    AnalyticsService,
    provideDataServices(),
  ],
};
